import AddThis from './../views/components/add-this/AddThis'
import Analytics from './../views/components/tracking/Analytics'
import Caroussel from './../views/components/carousel-block/Caroussel'
import CirkwiFilters from './../views/components/cirkwi/CirkwiFilters'
import CookiesBanner from './../views/components/cookie/CookiesBanner'
import FormCovid19 from './../views/components/form-covid19/FormCovid19'
import HeaderMenu from './../views/components/header/HeaderMenu'
import MoreLess from './../views/components/more-less/MoreLess'
import Player from './../views/components/player/Player'
import RangePicker from './../views/components/range-picker/RangePicker'
import Select from './../views/components/select/Select'
import HomePartners from './../views/components/home-partners/HomePartners'
import SwitchLanguage from './../views/components/footer/js/SwitchLanguage'
import InlineArticlePush from './../views/components/inline-article-push/InlineArticlePush'
import OverlayPush from './../views/components/overlay-push/OverlayPush'
import Gdpr from './../views/components/gdpr/Gdpr'

export {
    AddThis,
    Analytics,
    Caroussel,
    CirkwiFilters,
    CookiesBanner,
    FormCovid19,
    HeaderMenu,
    MoreLess,
    Player,
    RangePicker,
    Select,
    HomePartners,
    SwitchLanguage,
    InlineArticlePush,
    OverlayPush,
    Gdpr
}


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/js/kernel.js